export const COLOR_STATUS_PASSWORD_RESET = 'COLOR_STATUS_PASSWORD_RESET';
export const TEXT_STATUS_PASSWORD_RESET = 'TEXT_STATUS_PASSWORD_RESET';
export const IS_ACTIVE_ALERT_PASSWORD_RESET = 'IS_ACTIVE_ALERT_PASSWORD_RESET';
export const IS_ACTIVE_BUTTON_PASSWORD_RESET = 'IS_ACTIVE_BUTTON_PASSWORD_RESET';
export const IS_ACTIVE_FORM_PASSWORD_RESET = 'IS_ACTIVE_FORM_PASSWORD_RESET';
export const IS_LOADING_FORM_PASSWORD_RESET = 'IS_LOADING_FORM_PASSWORD_RESET';
